var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { memo } from "../../utils";
import { Availability } from "../Availability";
import { ParameterScopeProvider } from "../ParameterScopeProvider";
import { productInstanceKey, } from "../ProductInstance";
import { CustomParameterInstanceAvailabilityService } from "./CustomParameterInstanceAvailabilityService";
import { HalvingPolicyAvailabilityService } from "./HalvingPolicyAvailabilityService";
import { ModifierInstanceAvailabilityService } from "./ModifierInstanceAvailabilityService";
import { ProductInstancePartAvailabilityService } from "./ProductInstancePartAvailabilityService";
function fulfillmentTimeKey(fulfillmentTime) {
    if (fulfillmentTime === null) {
        return "null";
    }
    switch (fulfillmentTime.type) {
        case "ASAP":
            return "ASAP";
        case "OnTime":
            return `OnTime:${fulfillmentTime.date.toString()}`;
    }
}
let ProductInstancePureAvailabilityService = class ProductInstancePureAvailabilityService {
    constructor(modifierInstanceAvailabilityService, customParameterInstanceAvailabilityService, productInstancePartAvailabilityService, halvingPolicyAvailabilityService, parameterScopeProvider) {
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        this.customParameterInstanceAvailabilityService = customParameterInstanceAvailabilityService;
        this.productInstancePartAvailabilityService = productInstancePartAvailabilityService;
        this.halvingPolicyAvailabilityService = halvingPolicyAvailabilityService;
        this.parameterScopeProvider = parameterScopeProvider;
        makeImmutable(this);
    }
    availability(params) {
        const { productInstance, fulfillmentTime, fulfillmentMethod } = params;
        return memo([
            productInstanceKey(fulfillmentMethod, productInstance),
            fulfillmentTimeKey(fulfillmentTime),
        ], () => this.productInstanceAvailability(productInstance, fulfillmentTime, fulfillmentMethod));
    }
    productInstanceAvailability(productInstance, fulfillmentTime, fulfillmentMethod) {
        const parameterScope = this.parameterScopeProvider.fromProductInstance(productInstance, fulfillmentMethod);
        const modifierAvailabilities = productInstance.commonModifierInstances.objects.map((modifierInstance) => this.modifierInstanceAvailabilityService.availability(modifierInstance, parameterScope));
        const customParameterAvailabilities = productInstance.customParameterInstances.objects.map((customParameterInstance) => this.customParameterInstanceAvailabilityService.availability(customParameterInstance));
        return Availability.composite([
            Availability.dependent("ModifierInstance", "", Availability.composite(modifierAvailabilities.raw)),
            Availability.dependent("CustomParameterInstance", "", Availability.composite(customParameterAvailabilities.raw)),
            this.productInstancePartsAvailability(productInstance.parts, parameterScope, fulfillmentTime),
        ]);
    }
    productInstancePartsAvailability(productInstanceParts, parameterScope, fulfillmentTime) {
        switch (productInstanceParts.type) {
            case "SinglePart":
                return this.productInstancePartAvailabilityService.availability(productInstanceParts.part, parameterScope, fulfillmentTime);
            case "Halves":
                return Availability.composite([
                    this.halvingPolicyAvailabilityService.availability(productInstanceParts.productCategory.halvingPolicy, parameterScope),
                    this.productInstancePartAvailabilityService.availability(productInstanceParts.first, parameterScope, fulfillmentTime),
                    this.productInstancePartAvailabilityService.availability(productInstanceParts.second, parameterScope, fulfillmentTime),
                ]);
        }
    }
};
ProductInstancePureAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof CustomParameterInstanceAvailabilityService !== "undefined" && CustomParameterInstanceAvailabilityService) === "function" ? _b : Object, typeof (_c = typeof ProductInstancePartAvailabilityService !== "undefined" && ProductInstancePartAvailabilityService) === "function" ? _c : Object, typeof (_d = typeof HalvingPolicyAvailabilityService !== "undefined" && HalvingPolicyAvailabilityService) === "function" ? _d : Object, typeof (_e = typeof ParameterScopeProvider !== "undefined" && ParameterScopeProvider) === "function" ? _e : Object])
], ProductInstancePureAvailabilityService);
export { ProductInstancePureAvailabilityService };
